import {internalApi} from "../../common/axios";
import {useMutationBase, useQueryBase} from "../../shared/hooks/useHookBase";

const fetchEventManager = async () => {
    const {data} = await internalApi.get('events/manager');
    return data.rows;
}

export const useEventManager = () => {
    return useQueryBase('eventManager', fetchEventManager, {staleTime: 0});
}

const updateEventManager = async (body) => {
    await internalApi.post('events/manager', body);
}

export const useUpdateEventManager = () => {
    return useMutationBase('eventManager', updateEventManager);
};